export default "__VITE_ASSET__DN3eWN_n__"